import React, { useState } from 'react';
import PropTypes from 'prop-types';
import appConfig from 'app-config';
import _ from 'lodash';
import { useTranslator } from '@jutro/locale';
import { useModal } from '@jutro/components';
import { MetadataContent } from '@jutro/legacy/uiconfig';
import { MLBundleService } from 'ml-services-common-react';
import { AccountService } from 'gw-capability-gateway-policy';
import { FormModalPopover } from 'ml-components-platform-react';
import { MLAlertGroupComponent} from 'ml-components-common-react';
import { ViewModelServiceContext, ViewModelForm, useDataRefresh } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';

import metadata from './MLDeclineQuoteConfirmationComponent.metadata.json5';
import './MLDeclineQuoteConfirmationComponent.messages';
import styles from './MLDeclineQuoteConfirmationComponent.module.scss';

const MLDeclineQuoteConfirmationComponent = (props) => {
    const {
        onSave,
        onError,
        authHeader,
        declineButtionId,
        submissionVM,
        viewModel
    } = props;

    const translator = useTranslator();

    const [errorMessage, updateErrorMessage] = useState(undefined);
    const { onValidate: setComponentValidation, isComponentValid } = useValidation(submissionVM);
    const { refreshData } = useDataRefresh();

    const writeValue = (value, path) => {
            _.set(submissionVM.value, path, value);
            _.set(submissionVM, path, value);
            refreshData();
        };
    // TODO: extract to common util
    const parseErrorForMessage = (errorString) => {
        const indexOfMessages = errorString.indexOf('Messages_ML');
        let errorMessages = errorString.substring(indexOfMessages).split(']')[0];
        errorMessages = errorMessages.split('[')[1];
        return errorMessages.split(',')[0];
    };

    const handleError = (error) => {
        const errorMessageStringArray = error.baseError.split(' ');
        const outerErrorCodeIndex = error.baseError.indexOf('ErrorCode:');
        const outerErrorCodeValue = outerErrorCodeIndex !== -1 ? errorMessageStringArray[outerErrorCodeIndex + 1] : undefined;
        const outerErrorCodeNumericValue = !_.isUndefined(outerErrorCodeValue) ? parseInt(outerErrorCodeValue, 10) : undefined;
        if (outerErrorCodeNumericValue === appConfig.errorCodes.DISPLAYABLE_ERROR_ML) {
            updateErrorMessage(parseErrorForMessage(error.baseError));
        }
        onError(error);
    };

    
    const overrides = {
        errorMessage: {
            visible: !!errorMessage,
            content: errorMessage,
            className: styles.error
        },
        readtoCustomer:{
            visible:declineButtionId === 'readToCustomerButton' || declineButtionId === 'donwloadFormButton'
        },
        downloadForm:{
            visible:declineButtionId === 'donwloadFormButton' 
        },
        continue:{
            onClick:()=>{}
        }
    };

    const resolvers = {
        resolveClassNameMap: styles
    };

    return (
        <ViewModelForm
                    uiProps={metadata.pageContent}
                    componentMap={resolvers.resolveComponentMap}
                    classNameMap={resolvers.resolveClassNameMap}
                    model={submissionVM}
                    onValueChange={writeValue}
                    onValidationChange={setComponentValidation}
                    showErrors
                    overrideProps={overrides}
                    callbackMap={resolvers.resolveCallbackMap}
                />,
        <MetadataContent
            uiProps={metadata.componentContent}
            overrideProps={overrides}
            {...resolvers} />
    );
};

MLDeclineQuoteConfirmationComponent.propTypes = {
    accountNumber: PropTypes.string.isRequired,
    quoteNumber: PropTypes.string.isRequired,
    postalCode: PropTypes.string.isRequired,
    history: PropTypes.shape({}).isRequired,
    viewModelService: PropTypes.func.isRequired,
    onError: PropTypes.func
};

MLDeclineQuoteConfirmationComponent.defaultProps = {
    onError: _.noop
}
export default MLDeclineQuoteConfirmationComponent;

